import { useState, useEffect } from "react";
import VehiculeForm from "../components/VehiculeForm";
import VehiculeList from "../components/VehiculeList";

export default function VehiculesPage() {

  return (
    <div className="w-full max-w-screen-xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 pt-28 pb-8">
      <VehiculeList />
    </div>
  );
}
